var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59792 14.8403L13.1736 8.54592C13.9631 7.7902 13.9631 6.56494 13.1736 5.80923C12.3842 5.05351 11.1041 5.05351 10.3146 5.80923L3.78656 12.058C2.28652 13.4939 2.28652 15.8219 3.78656 17.2577C5.2866 18.6936 7.71864 18.6936 9.21868 17.2577L15.8421 10.9177C18.0526 8.80172 18.0526 5.37099 15.8421 3.25498C13.6315 1.13897 10.0474 1.13897 7.83682 3.25498L2.5 8.36347",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/Paperclip.9e357b833f2da52670c8160d0f8312f5.svg";
export { ForwardRef as ReactComponent };